//src/components/profile/Listcaruser.js
import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaRoad, FaGasPump, FaCogs, FaMapMarkerAlt } from "react-icons/fa";
import { API_URL } from "../../../config/api"; 

// Component Listcaruser: hiển thị thông tin một chiếc xe trong danh sách xe của người dùng
// Props:
// - car: object chứa thông tin xe (id, tên, năm, số km, loại nhiên liệu, hộp số, giá, vị trí, hình ảnh)
export default function Listcaruser({ car }) {
    // URL gốc của API backend (nên lấy từ biến môi trường để dễ thay đổi)
    const VITE_API_URL = API_URL;

    // Lấy link ảnh đầu tiên từ mảng car.images (được lưu dạng JSON string)
    // JSON.parse(car.images) sẽ chuyển chuỗi JSON thành mảng
    const imageSrc = VITE_API_URL + JSON.parse(car.images)[0];

    return (
        <Link
            to={`/properties/${car.id}`}
            className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition"
        >
            <img src={imageSrc} alt="" className="w-full h-40 object-cover" />
            <div className="p-3 text-sm text-blue-900 space-y-1">
                <h3 className="font-semibold text-base">{car.name}</h3>

                <div className="flex justify-between">
                    <span className="flex items-center gap-1 py-1"><FaCalendarAlt /> {car.year}</span>
                    <span className="flex items-center gap-1 py-1"><FaRoad /> {car.kilometers}</span>
                </div>
                <div className="flex justify-between">
                    <span className="flex items-center gap-1 py-1"><FaGasPump /> {car.fuel}</span>
                    <span className="flex items-center gap-1 py-1"><FaCogs /> {car.transmission}</span>
                </div>
                <p className="text-red-600 font-bold text-lg">{(car.price / 1000000).toLocaleString("vi-VN")} triệu</p>
                <p className="text-xs text-gray-500 flex items-center gap-1 mt-1"><FaMapMarkerAlt /> {car.location}</p>
            </div>
        </Link>
    );
}
